import PropTypes from 'prop-types';
import React from 'react';
import yup from 'yup';
import CharCount from '../../../Elements/CharCount/CharCount';
import { ValidateForm } from '../../../Includes/FormValidation';
import Button from '../../../Input/Button/Button';
import InputField from '../../../Input/InputField/InputField';
import TextArea from '../../../Input/TextArea/TextArea';
import './ReviewResponseForm.scss';

const MAX_TITLE_CHARS = 48;
const MAX_RESPONSE_CHARS = 5000;

export default class ReviewResponse extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            comment: '',
            jobTitle: '',
            errorcomment: '',
            errorjobTitle: '',
        };
    }
    static propTypes = {
        submitResponse: PropTypes.func,
    };
    static defaultProps = {};

    onTitleChange = (jobTitle) =>
        this.setState({ jobTitle, errorjobTitle: '' });
    onCommentChange = (comment) => this.setState({ comment, errorcomment: '' });

    submitResponse = async () => {
        const isValid = await this.validateForm();
        if (!isValid) {
            return;
        }
        const jobTitle = this.state.jobTitle.trim();
        const comment = this.state.comment.trim();
        this.props.submitResponse(comment, jobTitle);
    };
    validateForm = async () => {
        const responseSchema = {
            comment: yup
                .string()
                .max(
                    MAX_RESPONSE_CHARS,
                    'Please limit response to 5,000 characters'
                ),
            jobTitle: yup
                .string()
                .nullable()
                .max(MAX_TITLE_CHARS, 'Please limit title to 48 characters'),
        };
        const objectToValidate = {
            jobTitle: this.state.jobTitle,
            comment: this.state.comment,
        };
        return ValidateForm(objectToValidate, responseSchema, this.setError);
    };
    setError = (error) => this.setState(error);
    renderErrorMsg = (key) => {
        return this.state[key] ? (
            <strong className="error-text">{this.state[key]}</strong>
        ) : null;
    };
    render() {
        const jobTitle = this.state.jobTitle;
        const comment = this.state.comment;

        return (
            <div className="component-Community-ReviewResponseForm">
                <h2 className="response-form-header black">
                    Respond to review
                </h2>
                <div className="char-count-wrapper">
                    <div className="label-row">
                        <label htmlFor="job-title">Job title: (optional)</label>
                        <CharCount
                            length={jobTitle.length}
                            limit={MAX_TITLE_CHARS}
                        />
                    </div>
                    {this.renderErrorMsg('errorjobTitle')}
                    <InputField
                        name="job-title"
                        qaDataAttr="job-title"
                        onChange={this.onTitleChange}
                        classname=""
                        value={jobTitle}
                    />
                </div>
                <div className="char-count-wrapper">
                    <div className="label-row">
                        <label htmlFor="response-text">Response:*</label>
                        <CharCount
                            length={comment.length}
                            limit={MAX_RESPONSE_CHARS}
                        />
                    </div>
                    {this.renderErrorMsg('errorcomment')}
                    <TextArea
                        name="response-text"
                        qaDataAttr="response-text"
                        onChange={this.onCommentChange}
                        classname=""
                        value={comment}
                    />
                </div>
                <div className="button-row">
                    <Button
                        type="tertiary-blue-gray"
                        value="Cancel"
                        onClick={this.props.toggleReviewResponse}
                        inputStyle="button cancel-button"
                    />
                    <Button
                        type="purple-medium-white"
                        value="Post response"
                        onClick={this.submitResponse}
                        inputStyle="button submit-button"
                    />
                </div>
            </div>
        );
    }
}
